module.exports = __webpack_public_path__ + "img/chuzuche.a9582dd1.png";